import { table } from 'table'

const config = {
  border: {
    topBody: `-`,
    topJoin: `-`,
    topLeft: `+`,
    topRight: `+`,

    bottomBody: `-`,
    bottomJoin: `-`,
    bottomLeft: `+`,
    bottomRight: `+`,

    bodyLeft: `|`,
    bodyRight: `|`,
    bodyJoin: `|`,

    joinBody: `-`,
    joinLeft: `|`,
    joinRight: `|`,
    joinJoin: `|`
  }
}

export function objectTable(obj: any[]) {
  if(obj.length < 1) return

  let keys = Object.keys(obj[0])

  let tableData:any[] = [[...keys]]

  for(let objRow of obj) {
    let tableRow = []
    for(let key of keys) {
      tableRow.push(objRow[key])
    }
    tableData.push(tableRow)
  }

  return `\n${table(tableData, config)}`
}